/* eslint-disable @typescript-eslint/no-explicit-any */
import { CourseLessonDataInterface } from "@/ts/interfaces/Reporting/CourseLessonDataInterface";
import { GradeDetailInterface } from "@/ts/interfaces/Reporting/ReportingInterface";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getGradeDetailThunk } from "../thunks";
import { REQUEST_STATUS } from "@/ts/enums/RequestStatus";

export interface GradeDetailParams {
    eukaId: string;
    uniqueCourseIds: number[];
    studentId: number;
    gradeCode: number;
    courseLessonDetails: CourseLessonDataInterface[];
    hasCourseIdError: boolean;
}

export interface GradeDetailResult {
    eukaId: string;
    gradeCode: string;
    details: GradeDetailInterface;
    quizzesSummary: any;
    lessonSummary: any;
    assignmentSummary: any;
    totalLessonCount: number;
    isQuizAvailable: boolean;
}

export interface GradeDetailSlice {
    status: REQUEST_STATUS;
    isLoading: boolean;
    isSuccess: boolean;
    error: string | null;
    eukaId: string | null;
    gradeCode: string | null;
    gradeDetail: GradeDetailInterface | null;
    quizzesSummary: any | null;
    lessonSummary: any | null;
    assignmentSummary: any | null;
    totalLessonCount: number;
    isQuizAvailable: boolean;
}
interface ReportingGradeDetailState {
    status: REQUEST_STATUS;
    isLoading: boolean;
    isSuccess: boolean;
    error: string | null;
    data: GradeDetailResult | null;
}

const initialState: ReportingGradeDetailState = {
    isLoading: false,
    isSuccess: false,
    status: REQUEST_STATUS.IDLE,
    error: null,
    data: null
};

const reportingGradeDetailSlice = createSlice({
    name: "reporting/gradeDetail",
    initialState,
    reducers: {
        resetGradeDetailState: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(getGradeDetailThunk.pending, state => {
                state.isLoading = true;
                state.isSuccess = false;
                state.error = null;
                state.status = REQUEST_STATUS.PENDING;
            })
            .addCase(
                getGradeDetailThunk.fulfilled,
                (state, action: PayloadAction<GradeDetailResult>) => {
                    state.isLoading = false;
                    state.isSuccess = true;
                    state.data = action.payload;
                    state.status = REQUEST_STATUS.SUCCESS;
                }
            )
            .addCase(getGradeDetailThunk.rejected, (state, action) => {
                state.isLoading = false;
                state.isSuccess = false;
                state.error = action.payload ?? "Unknown error";
                state.status = REQUEST_STATUS.ERROR;
            });
    }
});

export const { resetGradeDetailState } = reportingGradeDetailSlice.actions;
export default reportingGradeDetailSlice.reducer;
